(function() {
  const initFontSize = 16;
  const iphone6Width = 375;
  const clientWidth =
    window.document.documentElement.clientWidth || iphone6Width;
  const newFontSize = initFontSize * (clientWidth / iphone6Width);
  document.documentElement.style.fontSize = newFontSize + "px";
})();



// WEBPACK FOOTER //
// ./src/utils/rem.js